// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import "./ReadMore.css";
// import Gfooter from "../Component/Gfooter";

// function ProductReadMore() {
//   const [products, setProducts] = useState([]);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null); // For carousel
//   const [carouselImages, setCarouselImages] = useState([]); // For full image list

//   const { id } = useParams();
//   const navigate = useNavigate();


//   // Open carousel
//   const openCarousel = (images, index) => {
//     setCarouselImages(images);
//     setSelectedImageIndex(index);
//   };

//   // Close carousel
//   const closeCarousel = () => {
//     setSelectedImageIndex(null);
//     setCarouselImages([]);
//   };

//   // Next image
//   const showNext = () => {
//     setSelectedImageIndex((prev) =>
//       prev + 1 < carouselImages.length ? prev + 1 : 0
//     );
//   };

//   // Previous image
//   const showPrev = () => {
//     setSelectedImageIndex((prev) =>
//       prev - 1 >= 0 ? prev - 1 : carouselImages.length - 1
//     );
//   };

//   // Fetch products
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details"
//         );

//         if (res.data.status && res.data.success === "1") {
//           let productList = res.data.data;

//           if (id) {
//             const filtered = productList.filter((item) => item.prod_id == id);
//             setProducts(filtered);
//           } else {
//             setProducts(productList);
//           }
//         } else {
//           setProducts([]);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching product data:", err);
//       }
//     };

//     fetchData();
//   }, [id]);

//   return (
//     <div className="read-top">
//       <div className="container">
//         <h1 className="our-heading">
//           {/* BACK BUTTON */}
//     <button
//       onClick={() => navigate(-1)}
//       className="btn  shadow-sm"
//       style={{
//         position: "absolute",
//         left: "20px",
//         top: "20px",
//         zIndex: 1000,
//         borderRadius: "50%",
//         width: "40px",
//         height: "40px",
//         fontSize: "18px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor:"red",
//       color:"white"      }}
//     >
//       ←
//     </button>
//           <strong>Our Offerings</strong>
//         </h1>

//         <div className="d-flex justify-content-end">
//           <a
//             href="/NLF - Roofing.pdf"
//             download
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <button className="btn btn-primary btn-sm me-2">
//               Download Brochure
//             </button>
//           </a>
//         </div>
//       </div>

//       {products.map((item) => {
//         // Multi images processing
//         let multiImages = [];
//         if (Array.isArray(item.multi_image)) {
//           multiImages = item.multi_image;
//         } else if (typeof item.multi_image === "string" && item.multi_image !== "") {
//           multiImages = item.multi_image.split(",");
//         }

//         const fullImageURLs = multiImages.map(
//           (img) => `https://cyberathon.com/NLF/${img}`
//         );

//         return (
//           <React.Fragment key={item.floor_id}>
//             <div className="container">
//               <h2 className="productmore-heading">
//                 <strong>{item.head1}</strong>
//               </h2>
//             </div>

//             <div className="container product-all">
//               <div className="row">
//                 <div className="productmore-detail col-lg-6 col-md-12 col-sm-12">
//                   <div className="productmore-info">
//                     <img
//                       src={`https://cyberathon.com/NLF/${item.floor_image}`}
//                       alt={item.head1}
//                     />
//                     <div
//                       className="productmore-content"
//                       dangerouslySetInnerHTML={{ __html: item.floor_paragraph }}
//                     />
//                   </div>
//                 </div>

//                 <div className="benefits col-lg-6 col-md-12 col-sm-12">
//                   <div dangerouslySetInnerHTML={{ __html: item.head2 }} />
//                 </div>
//               </div>

//               {/* ------------------------------- */}
//               {/* MULTI IMAGE SECTION - Only 3 Images */}
//               {/* ------------------------------- */}
//               <div className="d-flex justify-content-evenly mt-4 mb-4">
//                 {multiImages.length > 0 ? (
//                   <>
//                     {fullImageURLs.slice(0, 3).map((img, index) => (
//                       <div
//                         key={index}
//                         className="shadow p-3 bg-white rounded"
//                         onClick={() => openCarousel(fullImageURLs, index)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <img
//                           src={img}
//                           alt={`${item.head1}-${index}`}
//                           style={{
//                             height: "200px",
//                             width: "200px",
//                             borderRadius: "5px",
//                           }}
//                         />
//                       </div>
//                     ))}

//                     {multiImages.length > 3 && (
//                       <button
//                         className="btn btn-outline-primary"
//                         onClick={() => openCarousel(fullImageURLs, 0)}
//                       >
//                         View All Images
//                       </button>
//                     )}
//                   </>
//                 ) : (
//                   <p className="text-center text-muted">
//                     No additional images available.
//                   </p>
//                 )}
//               </div>
//             </div>
//           </React.Fragment>
//         );
//       })}

//       {/* ------------------------------- */}
//       {/* CAROUSEL MODAL */}
//       {/* ------------------------------- */}
//       {selectedImageIndex !== null && (
//         <div
//           onClick={closeCarousel}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.85)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               position: "relative",
//               width: "90%",
//               maxWidth: "900px",
//               textAlign: "center",
//             }}
//           >
//             <img
//               src={carouselImages[selectedImageIndex]}
//               style={{
//                 width: "100%",
//                 height: "auto",
//                 maxHeight: "80vh",
//                 borderRadius: "10px",
//                 objectFit: "contain",
//               }}
//               alt=""
//             />

//             {/* PREV BUTTON */}
//             <button
//               onClick={showPrev}
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "0",
//                 transform: "translateY(-50%)",
//                 fontSize: "30px",
//                 background: "none",
//                 border: "none",
//                 color: "#fff",
//                 cursor: "pointer",
//                 padding: "10px",
//               }}
//             >
//               ❮
//             </button>

//             {/* NEXT BUTTON */}
//             <button
//               onClick={showNext}
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "0",
//                 transform: "translateY(-50%)",
//                 fontSize: "30px",
//                 background: "none",
//                 border: "none",
//                 color: "#fff",
//                 cursor: "pointer",
//                 padding: "10px",
//               }}
//             >
//               ❯
//             </button>
//           </div>
//         </div>
//       )}

//       <Gfooter />
//     </div>
//   );
// }

// export default ProductReadMore;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./Product.css";
import "./ReadMore.css";
import Gfooter from "../Component/Gfooter";
import { Heading5 } from "lucide-react";

function MergedProductComponent(props) {
  // State for ProductDetail (Sub Cards)
  const [subCardData, setSubCardData] = useState([]);
  const [mainCardName, setMainCardName] = useState("");

  // State for ProductReadMore (Product Details)
  const [products, setProducts] = useState([]);

  // State for image viewing
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [carouselImages, setCarouselImages] = useState([]);

  const params = useParams();
  const mainId = props.mainId || params.mainId;
  const id = props.id || params.id;
  const navigate = useNavigate();

  // Fetch Sub Cards (from ProductDetail)
  useEffect(() => {
    const fetchSubCards = async () => {
      if (!mainId) return;

      try {
        const formData = new FormData();
        formData.append("main_id", mainId);

        const response = await axios.post(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_sub_cards",
          formData
        );

        if (response.data.status === true && response.data.data) {
          const filteredData = response.data.data.filter(
            (card) => card.main_id === mainId
          );
          setSubCardData(filteredData);
        }
      } catch (error) {
        console.error("Error fetching sub card data:", error);
      }
    };

    const fetchMainCard = async () => {
      if (!mainId) return;

      try {
        const formData = new FormData();
        formData.append("main_id", mainId);

        const response = await axios.post(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_by_id_main_card",
          formData
        );

        if (response.data.status === true && response.data.data) {
          setMainCardName(response.data.data.name);
        }
      } catch (error) {
        console.error("Error fetching main card data:", error);
      }
    };

    fetchSubCards();
    fetchMainCard();
  }, [mainId]);

  // Fetch Product Details (from ProductReadMore)
  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!id) return;

      try {
        const res = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_product_details"
        );

        if (res.data.status && res.data.success === "1") {
          
const productData = res.data.data;

const filtered = Array.isArray(productData)
  ? productData.filter((item) => item.prod_id == id)
  : productData?.prod_id == id
    ? [productData]
    : [];

setProducts(filtered);


          console.log("Full product object:", filtered[0]);
          console.log("HEAD2 value:", filtered[0]?.head2);

          setProducts(filtered);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("❌ Error fetching product data:", err);
      }
    };

    fetchProductDetails();
  }, [id]);

  
  // Update SEO metadata when product details are loaded
  useEffect(() => {
    if (!products.length) return;

    const product = products[0];

    const title =
      product.seo_title?.trim() ||
      product.head1?.trim() ||
      product.prod_heading?.trim() ||
      "NLF Solutions";

    const description =
      product.meta_description?.trim() ||
      product.prod_paragraph?.trim() ||
      "";

    const keywords = [
      product.primary_keyword,
      product.secondary_keywords,
      product.long_tail_keywords,
    ]
      .filter(Boolean)
      .join(", ");

    // Update browser title
    document.title = title;

    // Helper to create or update a meta tag
    const setMetaTag = (name, content) => {
      let tag = document.querySelector(
        `meta[name="${name}"]`
      );

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    // Update SEO meta tags
    setMetaTag("description", description);

    if (keywords) {
      setMetaTag("keywords", keywords);
    }

    // Open Graph metadata for social sharing
    const setPropertyTag = (property, content) => {
      let tag = document.querySelector(
        `meta[property="${property}"]`
      );

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    setPropertyTag("og:title", title);
    setPropertyTag("og:description", description);
  }, [products]);


  // Image Modal Functions
  const openImage = (src) => setSelectedImage(src);
  const closeImage = () => setSelectedImage(null);

  // Carousel Functions
  const openCarousel = (images, index) => {
    setCarouselImages(images);
    setSelectedImageIndex(index);
  };

  const closeCarousel = () => {
    setSelectedImageIndex(null);
    setCarouselImages([]);
  };

  const showNext = () => {
    setSelectedImageIndex((prev) =>
      prev + 1 < carouselImages.length ? prev + 1 : 0
    );
  };

  const showPrev = () => {
    setSelectedImageIndex((prev) =>
      prev - 1 >= 0 ? prev - 1 : carouselImages.length - 1
    );
  };

  // Determine what content to show
  const hasSubCards = subCardData.length > 0;
  const hasProductDetails = products.length > 0;

  return (
    <div className="read-top" style={{ backgroundColor: "#f0f0f0", marginTop: "52px" }}>

      {/* Sub Cards Section - Only show if available */}
      {hasSubCards && (
        <section className="product-section mb-0 bg-white">
          <div className="container">
            <div className="row mb-4">
              <div className="col-12">
                {mainCardName && (
                  <h2 className="text-center mt-3">{mainCardName}</h2>
                )}
              </div>
            </div>

            <div className="row">
              {subCardData.map((product, index) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 col-xs-12 article_padding card-sec"
                  key={index}
                >
                  <div className="offer_boxcontent">
                    <div className="upper_portion">
                      <div
                        className="article_img"
                        onClick={() =>
                          openImage(`https://cyberathon.com/NLF/${product.image}`)
                        }
                      >
                        <figure className="mb-0">
                          <img
                            src={`https://cyberathon.com/NLF/${product.image}`}
                            className="clickable-img"
                            alt={product.heading}
                          />
                        </figure>
                      </div>
                    </div>
                    <div className="lower_portion_wrapper">
                      <div className="lower_portion">
                        <h4 className="mb-0">{product.heading}</h4>
                      </div>
                      <Link
                        className="read_more text-white text-decoration-none"
                        to={`/Subcarddetails/${product.sub_id}`}
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Product Details Section - Only show if available */}
      {hasProductDetails && (
        <div className="container">
          <h1 className="our-heading">
            {/* Back Button */}
            <button
              onClick={() => navigate(-1)}
              className="btn shadow-sm"
              style={{
                position: "absolute",
                left: "20px",
                top: "40px",
                zIndex: 1000,
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "red",
                color: "white",
              }}
            >
              ←
            </button>

            <strong>Our Offerings</strong>
          </h1>


          {products.map((item) => {
            // Multi images processing
            let multiImages = [];
            if (Array.isArray(item.multi_image)) {
              multiImages = item.multi_image;
            } else if (typeof item.multi_image === "string" && item.multi_image !== "") {
              multiImages = item.multi_image.split(",");
            }

            const fullImageURLs = multiImages.map(
              (img) => `https://cyberathon.com/NLF/${img}`
            );

            return (
              <React.Fragment key={item.floor_id}>
                {item.pdf && (
                  <div className="d-flex justify-content-end mb-3">
                    <a
                      href={`https://cyberathon.com/NLF/${item.pdf}`}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn btn-primary btn-sm">
                        Download Brochure
                      </button>
                    </a>
                  </div>
                )}
                <div className="container">
                  <h1 className="productmore-heading">
                    <strong>{item.head1}</strong>
                  </h1>
                </div>

                <div className="container product-all">
                  <div className="row">
                    <div className="productmore-detail col-lg-6 col-md-12 col-sm-12">
                      <div className="productmore-info">
                        <img
                          src={`https://cyberathon.com/NLF/${item.floor_image}`}
                          alt={item.head1}
                        />
                        <div
                          className="productmore-content"
                          dangerouslySetInnerHTML={{ __html: item.floor_paragraph }}
                        />
                      </div>
                    </div>

                    <div className="benefits col-lg-6 col-md-12 col-sm-12">
                      <div dangerouslySetInnerHTML={{ __html: item.head2 }} />
                    </div>
                  </div>

                  {/* Multi Image Section - Only show if images available */}
                  {multiImages.length > 0 && (
                    <div className=" d-flex justify-content-center mt-4 mb-4 prodmultimgbox" style={{ gap: "10px" }}>
                      {fullImageURLs.slice(0, 3).map((img, index) => (
                        <div
                          key={index}
                          className="shadow p-3 bg-white rounded prodmultimgmidbox"
                          onClick={() => openCarousel(fullImageURLs, index)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={img}
                            alt={`${item.head1}-${index}`}
                            style={{
                              height: "200px",
                              width: "200px",
                              borderRadius: "5px",
                            }}
                            className="prodmultimg"
                          />
                        </div>
                      ))}

                      {multiImages.length > 3 && (
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => openCarousel(fullImageURLs, 0)}
                        >
                          View All Images
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      )}

      {/* No Content Message */}
      {!hasSubCards && !hasProductDetails && (
        <div className="container text-center py-5">
          <p className="text-muted">No content available.</p>
        </div>
      )}

      {/* Simple Image Modal for Sub Cards */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selectedImage} alt="Expanded" className="expanded-img" />
          </div>
        </div>
      )}

      {/* Carousel Modal for Product Details */}
      {selectedImageIndex !== null && (
        <div
          onClick={closeCarousel}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "90%",
              maxWidth: "900px",
              textAlign: "center",
            }}
          >
            <img
              src={carouselImages[selectedImageIndex]}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                borderRadius: "10px",
                objectFit: "contain",
              }}
              alt=""
            />

            <button
              onClick={showPrev}
              style={{
                position: "absolute",
                top: "50%",
                left: "0",
                transform: "translateY(-50%)",
                fontSize: "30px",
                background: "none",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                padding: "10px",
              }}
            >
              ❮
            </button>

            <button
              onClick={showNext}
              style={{
                position: "absolute",
                top: "50%",
                right: "0",
                transform: "translateY(-50%)",
                fontSize: "30px",
                background: "none",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                padding: "10px",
              }}
            >
              ❯
            </button>
          </div>
        </div>
      )}

      <Gfooter />
    </div>
  );
}

export default MergedProductComponent;